(function () {
  'use strict';

  function initCarousel(el) {
    var slides = Array.from(el.querySelectorAll('[data-slide]'));
    var dots   = Array.from(el.querySelectorAll('[data-dot]'));
    if (!slides.length) return;

    var current = 0;
    var timer;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].setAttribute('aria-selected', 'false'); }
      current = ((index % slides.length) + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-selected', 'true'); }
    }

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, 5000);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startTimer(); });
    });

    goTo(0);
    startTimer();
  }

  document.querySelectorAll('[data-carousel]').forEach(initCarousel);
})();
